import {
  Button,
  Checkbox,
  ConfigProvider,
  Form,
  Input,
  notification,
} from "antd";
import { jwtDecode } from "jwt-decode";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import API from "../../config/api";
import { addCounter, isSoleTrader } from "../../redux/slices/retailExpress";
import {
  login,
  setMailWerify,
  setToken
} from "../../redux/slices/userSlice";
import {
  POST,
} from "../../utils/apiCalls";
import "./styles.scss";
import { IoMailOutline } from "react-icons/io5";
import { RiLockPasswordLine } from "react-icons/ri";
import { BsEyeSlash } from "react-icons/bs";
import { BsEye } from "react-icons/bs";

function LoginScreen() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);

  async function getCounterDetails(val: any) {
    try {
      let url = API.POST_COUNTER;
      let obj = {
        adminid: val?.id,
        sdate: new Date(),
        sole_trader: true,
        staffid: val?.staff?.id,
        companyid: val?.staff?.companyid,
      };
      const response: any = await POST(url, obj);
      if (response.status === true) {
        dispatch(addCounter(response?.data));
        dispatch(isSoleTrader(true));
      }
    } catch (error: any) {
      notification.error({
        message: error?.response?.data?.message || "Error occurred",
      });
    }
  }

  const onFinish = async (data: any) => {
    try {
      setIsLoading(true);
      let url = "auth/staff/email-login";
      var loginRes: any = await POST( url, {
        ...data,
        type: "staff",
      });
      if (loginRes.status) {
        dispatch(setToken(loginRes?.data?.token));
        dispatch(
          login({
            data: loginRes?.data,
            auth: true,
          })
        );
        const decoded: any = jwtDecode(loginRes?.data?.token);
        if (decoded?.soleTrader) {
          await getCounterDetails(loginRes?.data);
        }
        if (loginRes?.data.emailverified) {
          dispatch(setMailWerify());
        }
        notification.success({
          message: "Success",
          description: "Logged in successfully",
        });
        navigate("/auth/dashboard");
      }
    } catch (error) {
      console.log(error);
      notification.error({
        message: "Failed",
        description: "Failed to login,Please try again later",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#36b372",
          fontFamily: "Regular",
          borderRadius: 4,
          colorTextPlaceholder: "#888c99",
        },
      }}
    >
      <div className="login-container">
        <div className="login-card">
          <h2 className="login-title">Sign in</h2>
          <p className="login-subtitle">Welcome back! Please enter your details below to sign in.</p>
          <Form
            style={{ width: "100%" }}
            onFinish={onFinish}
            autoComplete="off"
            layout="vertical"
          >
            <Form.Item
              name="email"
              rules={[
                {
                  required: true,
                  message: "Please input your email or username!",
                },
              ]}
            >
              <Input
                className="login_input"
                size="large"
                placeholder="Email or Employee Code"
                prefix={<IoMailOutline color="#888c99" />}
              />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please input your password!",
                },
              ]}
            >
              <Input.Password
                className="login_input"
                size="large"
                placeholder="Password"
                prefix={<RiLockPasswordLine color="#888c99" />}
                iconRender={(visible) => (visible ? <BsEyeSlash color="#888c99" /> : <BsEye color="#888c99" />)}
              />
            </Form.Item>
            <div className="login-actions">
              <Form.Item name="remember" valuePropName="checked" noStyle>
                <Checkbox>
                  Remember me
                </Checkbox>
              </Form.Item>
              <a
                onClick={() => navigate("/LoginHelp#")}
                className="forgot-password-link"
              >
                Forgot password?
              </a>
            </div>
            <Form.Item>
              <Button
                loading={isLoading}
                size="large"
                type="primary"
                block
                htmlType="submit"
                className="login_btn"
              >
                Sign In
              </Button>
            </Form.Item>
          </Form>
          {/* <div className="signup-text">
            Don't have an account?{" "}
            <a onClick={() => navigate("/signup")}>
              Sign up now
            </a>
          </div> */}
        </div>
      </div>
    </ConfigProvider>
  );
}

export default LoginScreen;
